module.exports = __webpack_public_path__ + "fd8317de976e78e3d8fd06d0da57b2e6.MP3";